import TabChange from './TabChange'

export default class {
  constructor() {

    const domTabChange = document.querySelector('.js-tab');
    if (domTabChange) new TabChange();
  }
}
